import {LngLat, MapMarker} from '@logistics-frontend/blocks'
import React from 'react'

import {classes} from './Point.classes'

type Props = {
  coords: LngLat
}

const Point: React.FC<Props> = props => {
  return (
    <MapMarker coordinates={props.coords}>
      <div className={classes.root} />
    </MapMarker>
  )
}

export default Point
